import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { 
    TouroperationRoutes, 
    HotelOfferRoutes, 
    VacationRentalRoutes,
    TravelerProfileRoutes,
    ReputationRoutes,
    HotelDemandRoutes,
    FlightsRoutes,
    AdminRoutes,
    DashboardRoutes,
    SessionRoutes
} from './pages'

const redirectRoute = [{
    path: '/',
    exact: true,
    needLogin: false,
    component: () => <Redirect to="/dashboard" />
},{
    exact: false,
    needLogin: false,
    component: () => <Redirect to="/404" />
}]

const routes = [
    ...TouroperationRoutes,
    ...HotelOfferRoutes,
    ...VacationRentalRoutes,
    ...TravelerProfileRoutes,
    ...ReputationRoutes,
    ...HotelDemandRoutes,
    ...FlightsRoutes,
    ...AdminRoutes,
    ...DashboardRoutes,
    ...SessionRoutes,
    ...redirectRoute
]

export default routes